/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { Button, Grid, Typography } from '@material-ui/core';
import { BasicDropzone } from '../../../shared/components/BasicDropzone';
import InfluencerTemplate from '../../../assets/Clients/Ambev/Influenciadores-template.xlsx';

interface UploadInputProps {
    changeUpload: (file: File) => void,
}

export function InfluencerUploadInput({ changeUpload }: UploadInputProps) {
    const classes = useInputStyles();

    const [file, setFile] = React.useState<File | null>(null);

    function getDisabledSubmit() {
        return (file == null);
    }

    return (
        <>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center">
                <Typography variant="h3" className={classes.title}>
                    Insira os dados solicitados
                </Typography>
                <Typography variant="body1" className={classes.item} style={{ textAlign: 'left' }}>
                    O preenchimento de todas as colunas é obrigatório. As colunas “Solicitante”, “Marca”, “Finalidade”, “RTB”, “Tamanho de Perfil” e “Pago ou Orgânico” devem seguir as categorias pré-definidas no modelo de Excel.<br/><br/>

                    Cada planilha deve conter as solicitações de apenas uma área (BDU, Regional, Partnership etc.)<br/>
                    Dentro dessa planilha deve haver apenas uma marca e um solicitante. <br/><br/>

                    No caso de Marketing Regional, é possível preencher mais de uma marca, mas somente 1 solicitante, para consumir somente a cota regional.
                </Typography>
                <Typography variant="subtitle1" className={classes.item} style={{ textAlign: 'left' }}>
                    A partir de 07/05/24 é obrigatório o preenchimento da coluna "Pago ou Orgânico". No momento da submissão faça o download do novo modelo de planilha.
                </Typography>
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.fields}
                    onClick={() => {
                        const link = document.createElement('a');
                        link.href = InfluencerTemplate;
                        link.download = 'InfluenciadoresTemplate.xlsx';
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }}
                >
                    Baixar modelo de planilha
                </Button>
                <BasicDropzone onChangefile={(file: File) => setFile(file)} isClipperSpreadsheetUpload={false} isInfluencerSpreadsheetUpload={true} />
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.fields}
                    disabled={getDisabledSubmit()}
                    onClick={() => { if (file) { changeUpload(file); } }}>
                    Próximo
                </Button>
            </Grid>
        </>
    );
}